<template>
  <PainelLayout>
    <Breadcrumb :lista="[ { 'name':'Painel', 'link' : '/' }]" />
    
    <div class="row">
      <div class="col-6">
        <h1>Tabelas de Preço</h1>
      </div>
      <div class="col-6 text-end">
        <router-link to="/tableprice/new">
          <button class="btn btn-primary mt-3">Nova Tabela</button>
        </router-link>
      </div>
    </div>
    <hr/>

    <app-table v-if="!loading" empty-message='nada encontrado'
    :colunas="[{ label: 'id' }, { label: 'Nome' }, {label: ''}]">
      <app-trow
        v-for="item in lista" :key="item.id"
        :data="[
          {value: item.id},
          {value: item.name}
        ]"
      >
      <template #actions>
        <router-link class="btn btn-sm btn-primary me-2" :to="{ path: '/tableprice/details', query: { id: item.id } }">
          <i class="bi bi-file-earmark-text me-2"></i>Ver +
        </router-link>
      </template>
      </app-trow>
    </app-table>

    <!-- Div Loading -->
    <div v-else class="d-flex justify-content-center p-3">
      <div class="spinner-border" style="width: 4rem; height: 4rem;" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>

    <div style="height: 15px;" ></div>
  </PainelLayout>
</template>

<script>
import PainelLayout from '@/layouts/PainelLayout.vue';
import { onMounted, ref, reactive } from 'vue';
import { Modal } from 'bootstrap';
import { tableprice } from '@/models/tableprice';
import Breadcrumb from '@/components/itens/breadcrumb.vue';
import { usePermissions } from '@/composables/usePermissions';
import AppTable from '@/components/AppTable.vue';
import AppTrow from '@/components/AppTrow.vue';

export default {
  name: "TablePriceView",
  components: {
    PainelLayout,
    Breadcrumb,
    AppTable,
    AppTrow
  },
  setup(props) {

    const lista = ref([]);
    const model = tableprice();
    const loading = ref(false);

    const clientobj = reactive({
      id: null,
      name: ''
    });

    const { isAdmin, isUser, isOpeto } = usePermissions();

    function openModal(elemento) {
      const modalObj = document.getElementById(elemento);
      modal = new Modal(modalObj);
      modal.show();
    };

    function closeModal() {
      modal.hide();
    };

    function showModal_delete(item) {
      clientobj.id = item.id;
      clientobj.name = item.name;
      msn_feedback.value = 'Tem certeza que deseja excluir este cliente?';
      openModal('modal_delete');
    }

    function confirmExcluir() {
      model.delet(clientobj.id).then((response) => {
        msn_feedback.value = 'Cliente excluído com sucesso.';
        list();
      }).catch((error) => {
        msn_feedback.value = 'Erro ao excluir cliente.';
      });
    }

    async function list() {
      try {
        lista.value = await model.list();
      } catch (error) {
        console.error('Erro ao listar tabelas de preço:', error);
      } finally {
        loading.value = false;
      }
    }

    onMounted(() => {
      list();
    });

    return {
      lista,
      clientobj,
      closeModal,
      openModal,
      showModal_delete,
      confirmExcluir,
      isAdmin,
      isUser,
      isOpeto,
      loading
    }
  }
}
</script>